import { Accordion, AccordionDetails, AccordionSummary, Card } from '@mui/material';
import styled from 'styled-components';
import { colors, fontFamilyPrimary, fontSize, fontWeight } from '../../../theme';
import { ButtonStyled } from '../../../theme/style';
import { ReactComponent as FilterImage } from '../../../assets/filters/filter.svg';

export const FilterBarStyled = styled(Card)`
&& {
    background-color: ${colors.grey000};
    box-shadow: none;
    border-radius: 8px;
    display: flex;
    width: 100%;
    break-after: avoid;
    break-inside: avoid;
    box-sizing: border-box;
}`;

export const FilterElementStyled = styled(Card)`
    && {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        position: relative;
        gap: 16px;
        box-shadow: none;
        width: 100%;
        /* The shared form control is sized for the closed bar, the panel wants
           the fixed column width of the design. */
        & .MuiFormControl-root {
            width: 256px;
            min-width: 256px;
            margin-right: 0;
        }
    }
`;

export const AddFilterButtonStyled = styled(ButtonStyled)`
  && {
    color: ${colors.grey300};
    font-weight: ${fontWeight.bold};
    padding: 16px;
    max-height: 44px;
    max-width: 56px;
    margin-right: 0px;
    align-self: flex-end;
    margin-bottom: 8px;
    background-color: ${colors.grey800};
    span {
      margin-right: 0px;
    }
    &:hover {
        color: ${colors.defaultHover};
    }
    &:active {
        font-weight: ${fontWeight.bold};
    }
    @media print{
        display: none;
    }
  }
`;

export const FilterImageStyled = styled(FilterImage)`
    && {
        width: 30px;
        min-width:30px;
    }
`;

export const AccordionStyled = styled(Accordion)(({ height }: {height: string}) => `
    && {
        font-family: ${fontFamilyPrimary};
        background-color: white;
        font-size: ${fontSize.sm};
        color: ${colors.grey100};
        width: auto;
        vetical-align: middle;
        border: none;
        box-shadow: none;
        border-radius: 8px;
        /* MUI positions the Accordion root, which would trap the dropdown panel
           at the width of this pill. Letting it out makes SelectFiltersBar the
           containing block, so the panel can span the whole bar. */
        position: static;
        margin-bottom: 15px;
        border-radius: 8px;
        height: ${height};
        ::before {
            display: none;
        };
        &&.Mui-expanded {
            margin: 0px 0px 15px 0px;
            height: max-content;
        };
        box-shadow: 0px 10px 60px rgba(33,22,69,0.04);
    }
    }
`);

export const AccordionDetailsStyled = styled(AccordionDetails)`
    && {
        background-color: #FFFFFF;
        box-sizing: border-box;
        padding: 24px;
        &&.Mui-selected {
            opacity: 1;
            max-height: 54px;
        };
        position: absolute;
        border-radius: 8px;
        z-index: 100;
        box-shadow: rgba(33, 22, 69, 0.16) 0px 10px 60px;
        /* Stretched across SelectFiltersBar, the nearest positioned ancestor. */
        top: auto;
        margin-top: 16px;
    }
`;

export const AccordionSummaryStyled = styled(AccordionSummary)(({ $hasSelection = false }: {$hasSelection?: boolean}) => `
    && {
        /* Tinted only once it carries a selection, plain white otherwise. */
        background-color: ${$hasSelection ? colors.defaultRGBA : colors.grey000};
        &:hover {
            background-color: ${colors.defaultRGBA};
        }
        max-height: 54px;
        max-width: 800px;
        border-radius: 8px;
        height: 54px;
        align-items: center;
        /* MUI wraps the children in this element, so centring and spacing have
           to be set here rather than on the summary itself. */
        & .MuiAccordionSummary-content {
            align-items: center;
            margin: 0;
            gap: 4px;
        }
        /* The icon is an svg, so first-of-type reaches the first summary. */
        & .MuiAccordionSummary-content > div:first-of-type {
            margin-left: 5px;
        }
        /* A summary that follows another one is separated from it by a slash.
           The first one only follows the icon, so it keeps none. */
        & .MuiAccordionSummary-content > div ~ div::before {
            content: '/';
            margin-right: 4px;
        }
        & .MuiAccordionSummary-content.Mui-expanded {
            margin: 0;
        }
        &&.Mui-expanded {
            max-height: 54px;
            margin-right: 10px;
            margin-bottom: 15px;
            min-height: 54px;
            margin: 0;
        };
    }
`);
